<template>
<v-app>

 <v-container fluid fill-height>
      <v-layout align-center justify-center>
     
    <v-flex xs12 sm4>
        <v-card class="elevation-12" v-if="!success">
                        
            <v-card-text>
              <div class="headline pb-3">Password Recovery Form</div>

                <v-text-field
                  v-model="email"
                  label="Email"
                  required
                ></v-text-field>



            <v-text-field
                v-model="newPassword"
                :append-icon="e1 ? 'visibility' : 'visibility_off'"
                :append-icon-cb="() => (e1 = !e1)"
                :type="e1 ? 'password' : 'text'"
                label="New Password"
                required
            ></v-text-field>
        
            </v-card-text>

                <v-card-actions>
                    <v-btn flat color="primary" to="login">BACK TO LOGIN</v-btn>                    
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click.native="resetPassword()">RESET</v-btn>
                </v-card-actions>

                <v-alert :value="true" type="error" dismissible v-model="error">
                    {{ errorMessage }}
                </v-alert>

            <!-- <v-card-text class="elevation-12">
                <v-card-media src="../../public/etracking-logo-long-large.gif" height="100px" contain >
                </v-card-media>
    
                <v-flex xs12 class="my-3">
                    <v-card>
                    <v-container fluid class="px-3">
                        
                    </v-container>
                   
                    </v-card>
                    -->
                    
                
                    <!--
                </v-flex> 
            </v-card-text> -->
      </v-card>
<v-card class="elevation-12" v-if="success">
  
<v-card-title primary-title>
              <div class="headline pb-3">Your password has been reset</div>
</v-card-title>
      <v-card-text>
          <p>
              {{ resultMessage }}
          </p>
                <p>
                    <router-link to="login">Click here to go to the login screen</router-link>
                </p>
        </v-card-text>
</v-card>
    </v-flex>
    
  </v-layout>
  </v-container>
</v-app>
        
       
</template>

<script>
    import { store } from '../store'
    import { postPasswordRecovery, initialize, BASE_URL } from '../utils/effort-tracking-api';

    export default {
    data() {
        return {
                email: "",
                newPassword: '',
                resultMessage: '',
                success: false,
                error: false,
                errorMessage: '',
                e1: true,
                e2: false,
                token: ''
        }
            
        },
        methods: {
            resetPassword() {

                this.error = false;
                this.success = false;

                initialize().then(x => {
                    
                    var model ={
                        "Email": this.email ,  
                        "Token": this.token,
                        "NewPassword": this.newPassword,
                        "Host": window.location.protocol + "//" + window.location.hostname 
                    };

                    console.log('Reseting password...');
                    
                    postPasswordRecovery(model).then(result => {
                        if (result.status == 200) 
                        {
                            this.success = true;
                            this.resultMessage = result.data;
                        } else {
                            console.log(result)
                            this.error = true;
                            this.errorMessage = result.response.data.toString();  
                            if (this.errorMessage.length < 5)
                                this.errorMessage = 'Something went wrong, please review your email address and try again.';    
                            console.log(result.response.data)
                        }
                    }).catch( ex => {
                        this.error = true;
                        this.errorMessage = 'Something went wrong, please try again';
                    });
                }).catch(ex => console.log(ex));
            }
        },
        mounted() {
            console.log(this.$route.query.token);
            this.token = this.$route.query.token;
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/PasswordRecovery.vue